import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { rtlEnable } from 'domain/env';

import { invertPinnedValue, invertPinnedState } from 'components/AgGrid/helpers';

const useAgGridRtlMethods = () => {
  const isRtl = useSelector(rtlEnable);

  const invertPinnedWhenRTL = useCallback((columns) => (isRtl ? invertPinnedValue(columns) : columns), [isRtl]);

  const invertPinnedStateWhenRTL = useCallback((state) => (isRtl ? invertPinnedState(state) : state), [isRtl]);

  return {
    invertPinnedWhenRTL,
    invertPinnedStateWhenRTL,
    enableRtl: isRtl,
  };
};

export default useAgGridRtlMethods;
